module.exports = __webpack_public_path__ + "static/media/features-split-image-03.2333f8f8.png";